import { render, staticRenderFns } from "./ManagerItem.vue?vue&type=template&id=181d2865&"
import script from "./ManagerItem.vue?vue&type=script&lang=js&"
export * from "./ManagerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports